module.exports = __webpack_public_path__ + "img/sobha.fefb4d1.jpg";